import type { IUserData } from '../../../../types/interfaces';
import GUIDUSER from '../consts';
import { GUIDKEYS } from '../types';

const isGuidValid = (user: IUserData, name: GUIDKEYS = GUIDKEYS.DEFAULT) => {
  const isValid =
    user &&
    Object.keys(user).length !== 0 &&
    user.sectionId === GUIDUSER[name ?? 'default'].sectionID &&
    GUIDUSER[name ?? 'default'].userGuid.includes(user.userGuid ?? '');
  return isValid;
};

export default isGuidValid;
